import React, { useState } from 'react';
import { FaHeart } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { getProfileImageUrl } from "../../utils/constants";
import './LikesModal.css';

const LikerAvatar = ({ liker }) => {
  const [imageFailed, setImageFailed] = useState(false);
  // Use the properly constructed profile_image_url from backend, with GCS path as fallback
  const primarySrc = liker.profile_image_url || getProfileImageUrl(liker.profile_image_gcs_path);
  const fallbackUiAvatarSrc = `https://ui-avatars.com/api/?name=${encodeURIComponent(
    liker.name || liker.preferred_name || liker.username || "NA"
  )}&background=random&color=fff&size=40&font-size=0.33`;

  const handleImageError = (e) => {
    if (e.target.src === primarySrc && primarySrc !== fallbackUiAvatarSrc) {
      e.target.src = fallbackUiAvatarSrc;
    } else {
      setImageFailed(true);
    }
  };

  const getInitials = (name, preferredName, username) => {
    const displayName = name || preferredName || username;
    if (displayName) {
      const names = displayName.split(" ").filter((n) => n);
      if (names.length > 1) {
        return (names[0][0] + names[names.length - 1][0]).toUpperCase();
      } else if (names.length === 1 && names[0].length > 1) {
        return names[0].substring(0, 2).toUpperCase();
      } else if (names.length === 1 && names[0].length) {
        return names[0][0].toUpperCase();
      }
    }
    return "U";
  };

  const cleanAltText = (name, preferredName, username) => {
    const text = name || preferredName || username || "User";
    return text.replace(/(\r\n|\n|\r)/gm, " ");
  };

  if (imageFailed || !primarySrc) {
    return (
      <div className="liker-avatar liker-avatar-initials">
        <span>{getInitials(liker.name, liker.preferred_name, liker.username)}</span>
      </div>
    );
  }

  return (
    <img
      src={primarySrc || fallbackUiAvatarSrc}
      alt={cleanAltText(liker.name, liker.preferred_name, liker.username)}
      className="liker-avatar"
      onError={handleImageError}
    />
  );
};

const LikesModal = ({ isOpen, onClose, likers, isLoading, providerName, API_URL }) => {
  if (!isOpen) return null;

  const totalLikes = likers.length;

  return (
    <div className="likes-modal-overlay" onClick={onClose}>
      <div className="likes-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="likes-modal-header">
          <h2 className="likes-modal-title">{providerName}</h2>
          <button className="likes-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="likes-modal-body">
          {totalLikes > 0 && (
            <div className="likes-summary">
              <FaHeart className="likes-heart-icon" />
              <span>
                {totalLikes} {totalLikes === 1 ? 'person has' : 'people have'} liked this recommendation
              </span>
            </div>
          )}

          {isLoading ? (
            <p>Loading...</p>
          ) : likers && likers.length > 0 ? (
            <ul className="likers-list">
              {likers.map((liker) => (
                <li key={liker.id}>
                  <Link to={`/pro/${liker.username}`} className="liker-item">
                    <LikerAvatar liker={liker} />
                    <div className="liker-info">
                      <span className="liker-name">{liker.name || liker.preferred_name}</span>
                      <span className="liker-username">@{liker.username}</span>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p>No one has liked this yet.</p>
          )}

          <div className="like-prompt">
            <FaHeart className="like-prompt-icon" />
            <span>Show your appreciation by liking recommendations you trust</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LikesModal; 